import { rootRoute } from './root'
import { listRoute } from './list'

export const identitiesRoute = rootRoute.addChildren([listRoute])
